import { PendingActions, EmojiEventsOutlined } from "@mui/icons-material";

import { ROUTES_PATHS } from "./RoutesPaths";
import { UsersIcon } from "../assets/Icons/UsersIcon";
import { DriversIcon } from "../assets/Icons/DriversIcon";
import { OwnersIcon } from "../assets/Icons/OwnersIcon";
import { GiftIcon } from "../assets/Icons/GiftIcon";
import { GiftCheckIcon } from "../assets/Icons/GiftCheckIcon";
import { GiftCrossIcon } from "../assets/Icons/GiftCrossIcon";
import { MapStrokeIcon } from "../assets/Icons/MapStrokeIcon";
import { VerificationRequestsIcon } from "../assets/Icons/VerificationRequestsIcon";
import { PendingRequestsIcon } from "../assets/Icons/PendingRequestsIcon";
import { RequestsHistoryIcon } from "../assets/Icons/RequestsHistoryIcon";
import { AdminsIcon } from "../assets/Icons/AdminsIcon";
import { StandardAdminsIcon } from "../assets/Icons/StandardAdminsIcon";
import { ReferralsProgramIcon } from "../assets/Icons/ReferralsProgramIcon";
import { ReferralsListIcon } from "../assets/Icons/ReferralsListIcons";
import { ReferralsRewardsIcon } from "../assets/Icons/ReferralsRewardsIcon";
import { OffersIcon } from "../assets/Icons/OffersIcon";
import { AnimationIcon } from "../assets/Icons/AnimationIcon";
import { ServiceCentersIcon } from "../assets/Icons/ServiceCenters";
import { ServicesIcon } from "../assets/Icons/Services";
import { MarketplaceIcon } from "../assets/Icons/MarketplaceIcon";
import { TrucksIcon } from "../assets/Icons/TrucksIcon";

const usersRoutes = {
  id: 1,
  title: "users",
  icon: <UsersIcon />,
  activekeys: ["users"],
  hasChildren: true,
  children: [
    {
      id: 1.1,
      title: "fleetOwners",
      icon: <TrucksIcon width={25} height={29} />,
      slug: ROUTES_PATHS.fleetOwners,
      activekeys: ["users/fleet-owners"],
    },
    {
      id: 1.2,
      title: "singleOwners",
      icon: <OwnersIcon />,
      slug: ROUTES_PATHS.singleOwners,
      activekeys: ["users/single-owners"],
    },
    {
      id: 1.3,
      title: "drivers",
      icon: <DriversIcon />,
      slug: ROUTES_PATHS.drivers,
      activekeys: ["users/drivers"],
    },
    {
      id: 1.3,
      title: "pendingDrivers",
      icon: <PendingActions sx={{ color: "white" }} />,
      slug: ROUTES_PATHS.pendingDrivers,
      activekeys: ["users/pending-drivers"],
    },
  ],
};

const rewardsRoutes = {
  id: 2,
  title: "rewards",
  icon: <GiftIcon />,
  activekeys: ["rewards"],
  hasChildren: true,
  children: [
    {
      id: 2.1,
      title: "liveRewards",
      icon: <GiftCheckIcon />,
      slug: ROUTES_PATHS.liveRewards,
      activekeys: ["rewards/live-rewards"],
    },
    {
      id: 2.2,
      title: "deletedRewards",
      icon: <GiftCrossIcon />,
      slug: ROUTES_PATHS.deletedRewards,
      activekeys: ["rewards/deleted-rewards"],
    },
  ],
};

const tripsRoutes = {
  id: 3,
  title: "trips",
  icon: <MapStrokeIcon />,
  activekeys: ["trips"],
  hasChildren: true,
  children: [
    {
      id: 3.1,
      title: "tripsOwners",
      icon: <TrucksIcon width={25} height={29} />,
      slug: ROUTES_PATHS.tripsOwners,
      activekeys: ["trips/owners"],
    },
    {
      id: 3.2,
      title: "tripsDrivers",
      icon: <DriversIcon />,
      slug: ROUTES_PATHS.tripsDrivers,
      activekeys: ["trips/drivers"],
    },
  ],
};

const verificationRequestsRoutes = {
  id: 4,
  title: "verificationRequests",
  icon: <VerificationRequestsIcon />,
  activekeys: ["verifications-requests"],
  hasChildren: true,
  children: [
    {
      id: 4.1,
      title: "pendingRequests",
      icon: <PendingRequestsIcon />,
      slug: ROUTES_PATHS.verificationRequestsPending,
      activekeys: ["verifications-requests/pending"],
    },
    {
      id: 4.2,
      title: "requestsHistory",
      icon: <RequestsHistoryIcon />,
      slug: ROUTES_PATHS.verificationRequestsHistory,
      activekeys: ["verifications-requests/history"],
    },
  ],
};

const adminsRoutes = {
  id: 5,
  title: "adminsManagement",
  icon: <AdminsIcon />,
  activekeys: ["admins"],
  hasChildren: true,
  children: [
    {
      id: 5.1,
      title: "standardAdmins",
      icon: <StandardAdminsIcon />,
      slug: ROUTES_PATHS.standardAdmins,
      activekeys: ["admins/standard-admins"],
    },
  ],
};

const referralRoutes = {
  id: 6,
  title: "referralProgram",
  icon: <ReferralsProgramIcon />,
  activekeys: ["referral-program"],
  hasChildren: true,
  children: [
    {
      id: 6.1,
      title: "referralsList",
      icon: <ReferralsListIcon />,
      slug: ROUTES_PATHS.referralsList,
      activekeys: ["referral-program/referral-list"],
    },
    {
      id: 6.2,
      title: "referralsRewards",
      icon: <ReferralsRewardsIcon />,
      slug: ROUTES_PATHS.referralsRewards,
      activekeys: ["referral-program/referral-rewards"],
    },
  ],
};

const servicesRoutes = {
  id: 9,
  title: "services",
  icon: <ServicesIcon />,
  activekeys: ["services"],
  hasChildren: true,
  children: [
    {
      id: 9.1,
      title: "serviceCenters",
      icon: <ServiceCentersIcon />,
      slug: ROUTES_PATHS.serviceCenters,
      activekeys: ["services/service-centers"],
    },
    // {
    //   id: 9.2,
    //   title: "marketplace",
    //   icon: <MarketplaceIcon />,
    //   slug: ROUTES_PATHS.marketplace,
    //   activekeys: ["services/marketplace"],
    // },
  ],
};

const offersRoutes = {
  id: 7,
  title: "offers",
  icon: <OffersIcon />,
  slug: ROUTES_PATHS.offers,
  activekeys: ["offers"],
  hasChildren: false,
};

const animationRoutes = {
  id: 8,
  title: "animations",
  icon: <AnimationIcon sx={{ color: "white" }} />,
  slug: ROUTES_PATHS.animations,
  activekeys: ["animations"],
  hasChildren: false,
};

const challengesRoutes = {
  id: 11,
  title: "challenges",
  icon: <EmojiEventsOutlined />,
  slug: ROUTES_PATHS.challenges,
  activekeys: ["challenges"],
  hasChildren: false,
};

export const SuperAdminSideMenuItems = [
  usersRoutes,
  verificationRequestsRoutes,
  rewardsRoutes,
  tripsRoutes,
  adminsRoutes,
  referralRoutes,
  offersRoutes,
  animationRoutes,
  servicesRoutes,
  challengesRoutes,
];

export const StandardAdminSideMenuItems = [
  usersRoutes,
  verificationRequestsRoutes,
  tripsRoutes,
  servicesRoutes,
  challengesRoutes,
];
